import { Component, Input, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import {AuthValidators} from '../../../../validators/auth.validators';

@Component({
  selector: 'app-sign-in-password-rules',
  templateUrl: './sign-in-password-rules.component.html',
  styleUrls: ['./sign-in-password-rules.component.scss']
})
export class SignInPasswordRulesComponent implements OnInit {

  @Input() password$: Subject<string>;

  errors = {
    format: {
      size: true,
      lowercase: true,
      uppercase: true,
      number: true,
      special: true
    }
  };

  constructor() {}

  ngOnInit() {
    this.password$.subscribe(password => (this.errors = AuthValidators.checkPassword(password)));
  }
}
